import { connect } from 'react-redux';
import { get } from 'lodash';

import { setMinStartTime } from '../utils';
import { TIME_PARAM_FORMAT } from '@eb/eds-utils';

const mapFormValuesToProps = (
    formState,
    { prefix = '', setRelativeMinTime },
) => {
    const formValues = formState.values || {};

    // Use _.get to deal with object prefix keys with arrays e.g. `a[0].lolcats`
    const startDate = get(formValues, `${prefix}startDate`);

    let minTime = '00:00';

    if (setRelativeMinTime && startDate) {
        minTime = setMinStartTime(startDate).format(TIME_PARAM_FORMAT);
    }

    return {
        minTime,
    };
};

const startTimeConnector = (component, getFormState, options = {}) =>
    connect((state) => mapFormValuesToProps(getFormState(state), options))(
        component,
    );

export default startTimeConnector;
